module.exports = __webpack_public_path__ + "static/media/antecipation_sucess.135d6a09.png";